import { create } from "zustand";
import { TimelineInterface } from "../types/chase-timeline-types";
import { IloanLogs } from "../types/loan-logs-type";

interface IdefaultValues {
    id: number | string,
    timeline: TimelineInterface[]
    logs: IloanLogs[]
    data?: Record<string, any>
}

const defaultValues = {
    id: "",
    timeline: [],
    logs: [],
    data: {}
}

interface IuseChaseMenu {
    onChaseMenuOpen: ({ id, }: IdefaultValues) => void,
    onChaseMenuClose: () => void
    onToggleChaseMenu: ({ id, }: IdefaultValues) => void
    initialValues: IdefaultValues
}

export const useChaseMenu = create<IuseChaseMenu>((set) => ({
    initialValues: defaultValues,
    onChaseMenuOpen: ({ id, data, timeline, logs }: IdefaultValues) => set({
        initialValues: { id, data, timeline, logs }
    }),
    onChaseMenuClose: () => set({
        initialValues: defaultValues
    }),
    onToggleChaseMenu: ({ id, data, timeline, logs }: IdefaultValues) => set((prevState) => ({
        initialValues: prevState.initialValues.id === id ? defaultValues : { id, data, timeline, logs }
    })),
}))
